/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

define([
	'textfit'
], (textfit) => {

	/**
	 *	This class is to wrap original TextFit with error handling
	 *
	 * @class TextFitUtil
	 */
	class TextFitUtil {
		// setter for mocking unit tests :(
		static set _textFit(func) {
			textfit = func;
		}
		/**
		 * This method adds addition error handling to TextFit
		 * If TextFit throws errors, force the inner span font size to 0.1px
		 *
		 * @static
		 * @param {*} el DOM single element
		 * @param {*} [options={}] options to extend default TextFit options
		 * @returns
		 * @memberof TextFitUtil
		 */
		static fillText(el, options = {}) {
			try {
				textfit(el, options);
			} catch (e) {
				this._forceFitText(el);
			}
		}

		/**
		 * This method is to set font size of inner span to 0.1px
		 * If there is no span, add one and set the font size to 0.1px
		 * If a span with class textFitted, set the font size to 0.1px
		 * @static
		 * @param {*} el DOM single element
		 * @memberof TextFitUtil
		 */
		static _forceFitText(el) {
			let originalHTML = el.innerHTML;
			let innerSpan = el.getElementsByClassName('textFitted');
			const defaultFontSize = '0.1px'; // Can't be 0 because IE freaks out.

			if (innerSpan[0]) {
				return innerSpan[0].style.fontSize = defaultFontSize;
			}

			innerSpan = document.createElement('span');
			innerSpan.className = 'textFitted';
			// Inline block ensure it takes on the size of its contents, even if they are enclosed
			// in other tags like <p>
			innerSpan.style['display'] = 'inline-block';
			innerSpan.innerHTML = originalHTML;
			innerSpan.style.fontSize = defaultFontSize;
			el.innerHTML = '';
			el.appendChild(innerSpan);
		}
	}

	return TextFitUtil;
});
